import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import {
  GetAllSSResponse,
  GetPatrimonioResponse,
  SismetroDetails,
  SismetroListType,
} from "../../../modules/serviceRequest/types";

const ROUTE = "/Sismetro";

export enum SismetroTipo {
  Acompanhamento = 60,
  Calibracao = 7,
  Conservacao = 221,
  Corretiva = 65,
  Melhoria = 9,
  Monitoramento = 110,
  Preditiva = 10,
  Preventiva = 182,
  ServicoAdministrativo = 15,
  Treinamento = 5,
}

type PostSismetro = {
  idSolicitante: number;
  idPatrimonio: number;
  urgencia: number;
  tendencia: number | null;
  gravidade: number | null;
  tipo: SismetroTipo;
  descricao: string;
  servicosRealizar: string;
  solicitadoPor: string | null;
  usinaId: number;
  alarmCode: string;
  alarmArea: string;
  alarmUg: string;
  alarmStartDate: string;
};

export async function getAllSS(
  idSolicitante: string,
  page: number,
  size: number,
  status: SismetroListType,
  startDate: Date | String | null,
  endDate: Date | String | null,
  idLocalizacao?: string
): Promise<GetAllSSResponse> {
  const config: AxiosRequestConfig = {
    params: {
      page: page,
      size: size,
      status: status,
      idSolicitante: idSolicitante,
      startDate: startDate,
      endDate: endDate,
      idLocalizacao: idLocalizacao,
    },
  };
  const result = await api.get<GetAllSSResponse>(`${ROUTE}`, config);
  return result.data;
}

export async function getSismetroDetails(id: number): Promise<SismetroDetails> {
  const result = await api.get(`${ROUTE}/${id}`);
  return result.data.ss;
}

export async function getSismetroPatrimonio(
  solicitanteId: number,
  idLocalizacao: string | null | undefined
): Promise<{ data: GetPatrimonioResponse[] }> {
  if (idLocalizacao && Number(idLocalizacao) === 0) {
    idLocalizacao = null;
  }

  if (idLocalizacao === "") {
    idLocalizacao = null;
  }

  const config: AxiosRequestConfig = {
    params: {
      solicitanteId: solicitanteId,
      idLocalizacao: idLocalizacao,
    },
  };
  const result = await api.get(`${ROUTE}/All/patrimonios`, config);
  return result.data;
}

export async function postSismetro(
  sismetro: PostSismetro
): Promise<{ id: number, hasSismetroError: boolean }> {
  const result = await api.post(`${ROUTE}/create`, sismetro);
  return result.data;
}
